import _ from 'ckLodash';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';
import styleUtils from 'utils/styleUtils';
import utils from 'utils/utils';

export default {
    contextSensitive: true,
    exec: function (editor, paramVal) {
        var applyStyle = _.partial(styleUtils.applyStyle, paramVal, 'line-height');
        selectionUtils.getSelectedBlocks(editor, true).forEach(applyStyle);
        this.setState(paramVal);
        setTimeout(function () {
            editor.execCommand('autogrow');
        }, 2);
    },
    refresh: function (editor, elementPath) {
        var range = selectionUtils.getSelectedRange(editor);
        if (!range) {
            return;
        }

        var firstBlock = rangeUtils.getStartAndEndBlock(range).startBlock;
        var state;
        if (!firstBlock) {
            state = null;
        } else {
            state = firstBlock.getStyle('line-height') || CKEDITOR.TRISTATE_OFF;
        }

        if (/px/.test(state)) {
            var parentBlock = utils.getBlockParent(elementPath);
            var baseSize = getComputedStyle(parentBlock.$)['font-size'];
            var emSize = Number((parseFloat(state) / parseFloat(baseSize)).toFixed(2));
            this.setState(emSize + 'em');
        } else {
            this.setState(state);
        }
    }
};
